<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      > -->
        <el-button
          slot="reference"
          type="danger"
          size="mini"
          style="margin-left: 10px"
          @click="openDelete"
        >删除</el-button>
        <div style="margin-left: 10px;color:#FF0000;">注意：所有用户都使用VIP0的配置</div>
    </div>
    <!-- <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">编号</label>
        <el-input
          v-model="sn"
          placeholder="请输入编号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">语种</label>
        <el-input
          v-model="lang"
          placeholder="请输入语种"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div> -->
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 251px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="vipLevel" label="针对VIP等级" width="100" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <el-form ref="form" :model="active" label-width="90px" size="mini">
        <el-form-item label="针对VIP等级">
          <el-input v-model="active.vipLevel" placeholder="针对VIP等级"/>
        </el-form-item>
        <el-form-item label="奖项1" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a1" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l1">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d1" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e1" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f1" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c1" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g1" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j1" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k1" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m1" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n1" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w1" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项2" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a2" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l2">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d2" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e2" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f2" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c2" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g2" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j2" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k2" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m2" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n2" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w2" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项3" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a3" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l3">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d3" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e3" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f3" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c3" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g3" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j3" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k3" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m3" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n3" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w3" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项4" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a4" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l4">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d4" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e4" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f4" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c4" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g4" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j4" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k4" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m4" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n4" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w4" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项5" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a5" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l5">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d5" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e5" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f5" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c5" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g5" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j5" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k5" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m5" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n5" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w5" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项6" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a6" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l6">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d6" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e6" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f6" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c6" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g6" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j6" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k6" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m6" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n6" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w6" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项7" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a7" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l7">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d7" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e7" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f7" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c7" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g7" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j7" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k7" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m7" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n7" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w7" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="奖项8" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
          <div >
            <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
                USDT金额
                <el-input v-model="active.a8" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
            </div>
            <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="active.l8">
              <el-radio style="margin-bottom: 10px;" :label="0">
                直接领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="1">
                加入群聊领取
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="2">
                本人参与
                <el-input v-model="active.d8" style="width: 60px;" placeholder="等级"/>
                次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="3">
                本人投资收藏
                <el-input v-model="active.e8" style="width: 60px;" placeholder=""/>
                USDT
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="5">
                本人收藏
               <el-input v-model="active.f8" style="width: 60px;" placeholder=""/>
               只宠物
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="6">
                邀请
               <el-input v-model="active.c8" style="width: 60px;" placeholder=""/>
               个好友注册
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="7">
                邀请
               <el-input v-model="active.g8" style="width: 60px;" placeholder=""/>
               个好友 投资收藏20USDT以上
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="8">
                邀请
               <el-input v-model="active.j8" style="width: 60px;" placeholder=""/>
               位好友参与ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="9">
                好友参与
               <el-input v-model="active.k8" style="width: 60px;" placeholder=""/>
               次ZooAB游戏
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="10">
                21层团队
               <el-input v-model="active.m8" style="width: 60px;" placeholder=""/>
               注册数
              </el-radio>
              <el-radio style="margin-bottom: 10px;" :label="11">
                21层团队投资收藏
               <el-input v-model="active.n8" style="width: 60px;" placeholder=""/>
               USDT
              </el-radio>
            </el-radio-group>
            <div>
                <span style="margin-right: 10px;">权重</span>
                <input v-model="active.w8" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
            </div>
          </div>
        </el-form-item>
         <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >添加</el-button>
        </el-popconfirm>
        </el-form-item>

      </el-form>
    </el-dialog>
    <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="900px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
    <!-- 表单 -->
     <el-form ref="form" :model="editForm" label-width="90px" size="mini">
        <el-form-item label="针对VIP等级">
          <el-input v-model="editForm.vipLevel" placeholder="针对VIP等级"/>
        </el-form-item>
        <el-form-item label="奖项1" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a1" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l1">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d1" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e1" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f1" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c1" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g1" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j1" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k1" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m1" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n1" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w1" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项2" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a2" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l2">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d2" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e2" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f2" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c2" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g2" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j2" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k2" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m2" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n2" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w2" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项3" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a3" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l3">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d3" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e3" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f3" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c3" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g3" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j3" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k3" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m3" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n3" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w3" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项4" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a4" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l4">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d4" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e4" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f4" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c4" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g4" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j4" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k4" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m4" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n4" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w4" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项5" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a5" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l5">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d5" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e5" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f5" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c5" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g5" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j5" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k5" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m5" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n5" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w5" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项6" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a6" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l6">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d6" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e6" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f6" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c6" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g6" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j6" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k6" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m6" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n6" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w6" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项7" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a7" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l7">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d7" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e7" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f7" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c7" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g7" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j7" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k7" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m7" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n7" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w7" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
<el-form-item label="奖项8" style="padding-bottom: 20px;border-bottom: 1px solid #CCCCCC; font-weight: 600;">
  <div >
    <div style="display: flex;margin-bottom: 10px;flex-wrap: wrap;">
        USDT金额
        <el-input v-model="editForm.a8" style="width: 160px;margin-left: 10px;" placeholder="金额"/>
    </div>
    <el-radio-group style="display: flex;flex-wrap: wrap;" v-model="editForm.l8">
      <el-radio style="margin-bottom: 10px;" :label="0">
        直接领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="1">
        加入群聊领取
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="2">
        本人参与
        <el-input v-model="editForm.d8" style="width: 60px;" placeholder="等级"/>
        次ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="3">
        本人投资收藏
        <el-input v-model="editForm.e8" style="width: 60px;" placeholder=""/>
        USDT
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="5">
        本人收藏
       <el-input v-model="editForm.f8" style="width: 60px;" placeholder=""/>
       只宠物
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="6">
        邀请
       <el-input v-model="editForm.c8" style="width: 60px;" placeholder=""/>
       个好友注册
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="7">
        邀请
       <el-input v-model="editForm.g8" style="width: 60px;" placeholder=""/>
       个好友 投资收藏20USDT以上
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="8">
        邀请
       <el-input v-model="editForm.j8" style="width: 60px;" placeholder=""/>
       位好友参与ZooAB游戏
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="9">
        好友参与
       <el-input v-model="editForm.k8" style="width: 60px;" placeholder=""/>
       次ZooAB游戏
      </el-radio> 
      <el-radio style="margin-bottom: 10px;" :label="10">
        21层团队
       <el-input v-model="editForm.m8" style="width: 60px;" placeholder=""/>
       注册数
      </el-radio>
      <el-radio style="margin-bottom: 10px;" :label="11">
        21层团队投资收藏
       <el-input v-model="editForm.n8" style="width: 60px;" placeholder=""/>
       USDT
      </el-radio>
    </el-radio-group>
    <div>
        <span style="margin-right: 10px;">权重</span>
        <input v-model="editForm.w8" class="input" style="width: 160px;font-size:16px;color:red;" placeholder="请输入权重"/>
    </div>
  </div>
</el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="update()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新</el-button>
        </el-popconfirm>
        </el-form-item>
     </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap,UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], // 
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      sn:'',
      lang:'en',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      dataTime:['',''],
      yifangId:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 打开编辑弹窗
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.edit_dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.image.init(this.editForm.image)
      })
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
        .drawConfigList(params)
        .then((res) => {
          this.tableData = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .drawConfigDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.active = {}
      this.active.t1 = 0
      this.active.t2 = 0
      this.active.t3 = 0
      this.active.t4 = 0
      this.active.t5 = 0
      this.active.t6 = 0
      this.active.t7 = 0
      this.active.t8 = 0
      
    },
    happenTimeFun(num){
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d
},
    // 添加用户
    bannerSave() {
          this.$api.operate
            .drawConfigSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 添加用户
    update() {
          this.$api.operate
            .drawConfigUpdate(this.editForm)
            .then((res) => {
              this.$message.success(res);
              this.edit_dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio-group{
    align-items: center;
}
.input{
    color: red !important;
}
::v-dee .el-radio{
  margin-bottom: 10px !important;
}
.flex{
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    
}
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
    display: flex;
    align-content: center;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
